import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { auth } from '../../firebase';
import { API_URL, SOCKET_URL } from '../../apiConfig';

const HistoryPage = () => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const user = auth.currentUser;
                if (!user) {
                    setLoading(false);
                    return;
                }
                const idToken = await user.getIdToken();
                const response = await axios.get(`${API_URL}/users/history`, {
                    headers: { Authorization: `Bearer ${idToken}` },
                });
                setHistory(response.data);
            } catch (err) {
                console.error("Error fetching history:", err);
                setError("Could not load your volunteer history.");
            } finally {
                setLoading(false);
            }
        };

        fetchHistory();
    }, []);

    return (
        <motion.div
            key="history"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="p-4 md:p-8 max-w-5xl mx-auto"
        >
            <div className="mb-8">
                <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
                    Volunteer History
                </h1>
                <p className="text-gray-600 mt-1">A record of your contributions and impact.</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200">
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead className="bg-gray-50 border-b border-gray-200">
                            <tr>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Event</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">NGO</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Date Completed</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right">Points Earned</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {loading ? (
                                <tr><td colSpan="4" className="text-center p-4">Loading history...</td></tr>
                            ) : error ? (
                                <tr><td colSpan="4" className="text-center p-4 text-red-500">{error}</td></tr>
                            ) : (
                                history.map((item, index) => (
                                    <motion.tr 
                                        key={item._id}
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: index * 0.05 }}
                                        className="hover:bg-gray-50 transition-colors"
                                    >
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm font-medium text-gray-900">{item.title}</div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-600">{item.postedBy?.organizationName || 'N/A'}</div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-600">{new Date(item.updatedAt).toLocaleDateString()}</div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-right">
                                            <span className="text-sm font-semibold text-green-600">+{item.points}</span>
                                        </td>
                                    </motion.tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
                 {!loading && history.length === 0 && (
                    <div className="text-center py-10">
                        <p className="text-gray-500">You haven't completed any volunteer activities yet.</p>
                    </div>
                )}
            </div>
        </motion.div>
    );
};

export default HistoryPage;
